import React from "react";

import { observer } from "mobx-react";
import Head from "next/head";
import Script from "next/script";

import { useStores } from "../../contexts/StoreContext";

function GoogleAnalytics() {
  const { configStore } = useStores();
  const { config } = configStore;

  const googleId = config?.googleMeasurementID;
  const googleVerification = config?.googleSiteVerification;
  const isGtm = config?.useGtm;

  if (typeof window !== "undefined" && googleId) {
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line func-names
    window.gtag = function (args) {
      window.dataLayer.push(args);
    };
    window.gtag("js", new Date());
    window.gtag("config", googleId);
  }

  const gtagSrc = `https://www.googletagmanager.com/gtag/js?id=${config?.googleMeasurementID}`;

  const gtmScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer', '${googleId}')`;

  return (
    <>
      {googleId && !isGtm && (
        <Script src={gtagSrc} strategy="afterInteractive" />
      )}
      {googleId && isGtm && (
        <>
          <Script
            dangerouslySetInnerHTML={{ __html: gtmScript }}
            id="gtm"
            strategy="afterInteractive"
          />
          <noscript>
            <iframe
              height="0"
              src={`https://www.googletagmanager.com/ns.html?id=${googleId}`}
              style={{ display: "none", visibility: "hidden" }}
              title="gtm"
              width="0"
            />
          </noscript>
        </>
      )}
      {googleVerification && (
        <Head>
          <meta content={googleVerification} name="google-site-verification" />
        </Head>
      )}
    </>
  );
}

export default observer(GoogleAnalytics);
